import ManageTeamList from "./ManageTeamList";

export default ManageTeamList;
